import Axios from 'axios'

let axios = Axios.create({
  headers: {}
});


const getCountry = function () {
  return new Promise((resolve, reject) => {
    axios.get('https://ipinfo.io/json').then(
      res => {
        resolve(res.data.country)
      }, err => {
        reject(err)
      }
    )
  });
};

export default getCountry;
